import { createFileRoute } from "@tanstack/react-router";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { PageError } from "@/features/auth/components/PageError";
import { usePageState } from "@/hooks/usePageState";
import { OverviewPage } from "@/features/overview/components/OverviewPage";
import { exploreRouteValidateSearch } from "@/features/dashboard/lib/explore-search-route";

function OverviewRoute() {
  const { isLoading, error } = usePageState("overview");
  if (isLoading) return null;
  if (error) return <PageError is403={error instanceof PageAccessError} />;
  return <OverviewPage />;
}

export const Route = createFileRoute("/_authenticated/overview")({
  beforeLoad: () => assertPagePermission("overview"),
  validateSearch: exploreRouteValidateSearch,
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("overview"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: OverviewRoute,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});
